import { defineAction } from '~/prix'
import { z } from 'zod'
import inseminatorCreateAction from './inseminatorCreate.action.json' with { type: 'json' }
import { inseminatorObject } from '../inseminatorObject'

const inseminatorCreateDefinition = defineAction({
  ...inseminatorCreateAction,

  input: inseminatorObject
    .pick({
      id: true,
      citizenId: true,
    })
    .partial({
      id: true,
    }),
  output: inseminatorObject.pick({
    id: true,
    code: true,
  }),
})

export default inseminatorCreateDefinition
